enum NotificationSeverity {
  Information = 1,
  Success = 2,
  Warning = 3,
  Error = 4
}
export default NotificationSeverity;

const _notificationSeverityToString = (value: NotificationSeverity) => {
  switch (value) {
    case NotificationSeverity.Information:
      return 'info';
    case NotificationSeverity.Success:
      return 'success';
    case NotificationSeverity.Warning:
      return 'warning';
    case NotificationSeverity.Error:
      return 'error';
    default:
      return undefined;
  }
};
